import styled, { css } from 'styled-components'
import { Form } from 'lib/ui/components'
import { bp } from 'lib/core/resources/helpers/styled'
import caretDown from 'resources/svg/icons/caret-down.svg'

export const ReactSelectTheme = styled(Form.ReactSelectTheme.Wrapper)`
  display: flex;

  > label {
    display: flex;
    align-items: center;
    margin-right: 10px;
    color: ${props => props.theme.palette.general.strong};
    white-space: nowrap;
  }

  > div {
    width: 100%;
    min-width: 225px;
  }

  .react-select {
    &__control {
      border-radius: 3px;
      border-color: ${props => props.theme.palette.general.grey};

      &:hover,
      &--is-focused {
        box-shadow: none;
        border-color: ${props => props.theme.palette.general.strong};
      }
    }

    &__indicator-separator {
      background: transparent;
    }

    &__menu {
      margin-top: 0;
      padding: 0 10px;
      box-shadow: 0 2px 7px 1px rgba(183, 183, 183, 0.6);
    }

    &__option {
      color: ${props => props.theme.palette.general.grey};

      &:not(:last-of-type) {
        border-bottom: 1px solid ${props => props.theme.palette.general.grey};
      }

      &--is-focused,
      &--is-selected {
        background: transparent;
        color: ${props => props.theme.palette.general.strong};
      }
    }
  }

  ${props => props.labelInside && css`
    position: relative;
    display: inline-flex;
    min-width: 260px;
    ${bp('sm')`
      min-width: unset;
      width: 80%;
    `}

    > label {
      position: absolute;
      z-index: 1;
      left: 20px;
      top: 0;
      bottom: 0;
    }

    .react-select {
      &__control {
        border-radius: 3px;
      }

      &__value-container {
        padding-left: 75px;
      }
  
      &__single-value {
        font-weight: bold;
      }

      &__indicator-separator,
      &__placeholder {
        display: none;
      }

      &__indicator {
        position: relative;

        svg {
          display: none;
        }

        &::before {
          content: '';
          width: 20px;
          height: 14px;
          background: url(${caretDown}) no-repeat center;
          background-size: 14px;
          right: 10px;
        }
      }
    }
  `}
`
